<template>
  <div
    class="group relative bg-white dark:bg-dark-surface rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-primary/20 dark:hover:border-primary/30 will-change-transform"
  >
    <!-- Icon Container -->
    <div
      class="w-14 h-14 bg-gradient-to-br from-primary/10 to-primary/5 dark:from-primary/20 dark:to-primary/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
    >
      <component
        :is="icon"
        :size="28"
        class="text-primary dark:text-primary-300 group-hover:rotate-6 transition-transform duration-300"
      />
    </div>

    <!-- Content -->
    <h3 class="text-xl font-display font-bold text-gray-900 dark:text-white mb-3">
      {{ title }}
    </h3>

    <p class="text-gray-600 dark:text-gray-400 leading-relaxed">
      {{ description }}
    </p>

    <!-- Hover Glow Effect -->
    <div
      class="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 dark:from-primary/10 dark:to-accent/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: Object,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  }
});
</script>
